import React from 'react';
import { ButtonProps } from '../../Components/Button';
import { MinusIcon, PlusIcon, ReloadIcon } from '../../Components/Icons';
import { MenuButton, MenuItem } from '../../Components/MenuButton/MenuButton';
import { MedicationListResponse } from '../../Contracts/MedicationList.Response';
import { ListBulkAction } from '../../Contracts/MedicationListModels';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';

export function MedicationListBulkActionButton(
    props: ButtonProps & { medicationList: MedicationListResponse; onBulkActionClicked(action: ListBulkAction): void }
) {
    const { onBulkActionClicked, ...buttonProps } = props;
    if (props.medicationList.status === MedicationListStatus.Published) return null;

    return (
        <MenuButton {...buttonProps} label='Bulk'>
            {config => (
                <>
                    <MenuItem
                        title='Bulk add list items'
                        testId='add'
                        startIcon={<PlusIcon size={'20'} />}
                        onClick={() => {
                            config.closeMenu();
                            onBulkActionClicked(ListBulkAction.Append);
                        }}
                    />
                    <MenuItem
                        title='Bulk remove list items'
                        testId='remove'
                        startIcon={<MinusIcon size={'20'} />}
                        onClick={() => {
                            config.closeMenu();
                            onBulkActionClicked(ListBulkAction.Remove);
                        }}
                    />
                    <MenuItem
                        title='Sync medication list data'
                        testId='sync'
                        startIcon={<ReloadIcon size={'20'} />}
                        onClick={() => {
                            config.closeMenu();
                            onBulkActionClicked(ListBulkAction.Sync);
                        }}
                    />
                </>
            )}
        </MenuButton>
    );
}
